<crm-single-select
  #singleSelectComponent
  [options]="bankDetails"
  [(selectedItem)]="selectedBankDetail"
  (selectedItemChange)="selectedBankDetailChange.emit($event)"
  [label]="labelInput ? 'Расчетный счет' : ''"
  [virtualScroll]="true"
  [virtualScrollItemSize]="64"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [isTemplateCombined]="true"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [disabled]="disabled"
  (onShow)="onShowPanel()"
  optionLabel="id"
  filterBy="checkingAccount,bank.name,name">
  <ng-template
    #itemTemplate
    let-bankDetail="item">
    <div
      *ngIf="toBankDetail(bankDetail) as bankDetail"
      class="white-space-normal py-2">
      <div
        *ngIf="bankDetail.name"
        class="mb-1">
        <span [innerHTML]="highlightMatchText(bankDetail.name) | safeHtml"></span>
      </div>
      <div
        *ngIf="bankDetail.bank"
        class="text-gray-500">
        <span [innerHTML]="highlightMatchText(bankDetail.bank.name) | safeHtml"></span>
      </div>
      <div class="frm-color-green">
        <span [innerHTML]="highlightMatchText(bankDetail.checkingAccount) | safeHtml"></span>
      </div>
    </div>
  </ng-template>
</crm-single-select>
